import { useCategory9006 } from "./9006";

export function useCategory9005() {
  const category9006 = useCategory9006();

  return category9006;
}
